import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {BiLockOpen} from "react-icons/bi";
import {client} from "../../dataProvider";
import {useListContext} from "react-admin";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {useState} from "react";
import {ContextEmail} from "./ContextEmail";


export function EmailDeliveryField({send_email, delivery_id, email_sent_obj}: {
    send_email: boolean,
    delivery_id: string | number,
    email_sent_obj: any
}) {
    const {refetch} = useListContext()
    const [open, setOpen] = useState(false)
    const handleClick = async () => {
        await client(`deliveries/${delivery_id}`, {
            method: "PUT",
            data: {
                send_email: false
            }
        }).then((response) => {
            alert("Email sbloccata")
            refetch()
        }).catch((error) => {
            alert("Errore")
        })
    }


    const params = email_sent_obj?.params;

    return send_email ? (
        <div>
            <Button title={"Visualizza mail"} onClick={() => setOpen(true)}><VisibilityIcon/></Button>
            <Button onClick={handleClick} title="Sblocca mail"><BiLockOpen size={21}/></Button>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
                <DialogActions><Button onClick={()=> setOpen(false)}>X</Button></DialogActions>
                <DialogTitle>Email inviata a {params?.email || "-"} </DialogTitle>
                <DialogContent>
                    {params && <ContextEmail
                        notes={params.mission_notes || "-"}
                        client_name={params.client_name}
                        ddt_number={params.ddt_number || params.mission_name}
                        ddt_date={params.ddt_date}
                        mission_number={params.mission_number || params.id}
                        mission_date={params.mission_date}
                        status={params.mission_status}
                        reason={params.mission_reason}
                        signatory={params.signatory}
                    />}
                </DialogContent>
            </Dialog>
        </div>
    ) : null
}
